// Lädt die 5.2-Schriften nur innerhalb der eingeloggten CONTROL-Oberfläche (eigene Familiennamen, Login unberührt).
const FACES = [
  ["F52 Satoshi", "/fonts/satoshi/Satoshi-Black.woff2", "900"],
  ["F52 Cabinet Grotesk", "/fonts/cabinet-grotesk/CabinetGrotesk-Medium.woff2", "500"],
  ["F52 Cabinet Grotesk", "/fonts/cabinet-grotesk/CabinetGrotesk-Bold.woff2", "700"],
  ["F52 Cabinet Grotesk", "/fonts/cabinet-grotesk/CabinetGrotesk-Extrabold.woff2", "800"],
];
let loaded = false;

export function loadF52Fonts() {
  if (loaded || typeof FontFace === "undefined" || !document.fonts) return;
  loaded = true;
  FACES.forEach(([family, url, weight]) => {
    const face = new FontFace(family, `url(${url}) format("woff2")`, { weight, style: "normal", display: "swap" });
    face.load().then((f) => document.fonts.add(f)).catch(() => {});
  });
}
